import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router';

import { LogoLoading } from "../../components/Loading";
import Sidebar from '../../components/Sidebar';
import { useSelector } from 'react-redux';
import { DOCTOR_ROLE } from '../../constants';

// page imports
const Dashboard = React.lazy(() => import('../../pages/Doctor/Dashboard'));
const Profile = React.lazy(() => import('../../pages/Account'));
const AddBillingMethod = React.lazy(() => import('../../pages/Doctor/AddBillingMethod'));
const BillingMethodListing = React.lazy(() => import('../../pages/Doctor/BillingMethodListing'));
const BillingListing = React.lazy(() => import('../../pages/Doctor/BillingListing'));
const BillingMethodDetail = React.lazy(() => import('../../pages/Doctor/BillingMethodDetail'));
const AddClinic = React.lazy(() => import('../../pages/Doctor/AddClinic'));
const ClinicListing = React.lazy(() => import('../../pages/Doctor/ClinicListing'));
const ClinicDetail = React.lazy(() => import('../../pages/Doctor/ClinicDetail'));
const AddCase = React.lazy(() => import('../../pages/Doctor/AddCase'));
const CaseListing = React.lazy(() => import('../../pages/Doctor/CaseListing'));
const CaseDetail = React.lazy(() => import('../../pages/Doctor/CaseDetail'));
const Support = React.lazy(() => import('../../pages/SupportListing/Listing'));
const SupportDetail = React.lazy(() => import('../../pages/SupportDetail'));
// const CoursesListing = React.lazy(() => import('../../pages/Admin/CoursesListing'));
const Courses = React.lazy(() => import('../../pages/Admin/Courses'));
const CourseDetail = React.lazy(() => import('../../pages/Admin/CourseDetail'));
const Patients = React.lazy(() => import('../../pages/Doctor/Patients'));
const Deliveries = React.lazy(() => import('../../pages/Doctor/Deliveries'));
const Stats = React.lazy(() => import('../../pages/Doctor/Stats'));
const Users = React.lazy(() => import('../../pages/Doctor/Users'));
const UserDetail = React.lazy(() => import('../../pages/Doctor/UserDetail'));
const Indexes = React.lazy(() => import('../../pages/Doctor/Indexes'));
const IndexesDetail = React.lazy(() => import('../../pages/Doctor/IndexesDetail'));
const CephAnalysis = React.lazy(() => import('../../pages/Doctor/CephAnalysis'));
const CephAnalysisDetail = React.lazy(() => import('../../pages/Doctor/CephAnalysisDetail'));
const DoctorCaseStudies = React.lazy(() => import('../../pages/Doctor/CaseStudies'));
const DoctorCaseStudyDetail = React.lazy(() => import('../../pages/Doctor/CaseStudies/Detail'));

// page imports

function AdminRoutes(props) {
  const user = useSelector(state => state.user)
  return (
    <>
      <Sidebar />
      <Suspense fallback={<LogoLoading />}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          {
            user.role === DOCTOR_ROLE ?
              <>
                <Route path="/team" element={<Users />} />
                <Route path="/team/:id" element={<UserDetail />} />
                <Route path="/billing" element={<BillingListing />} />
                <Route path="/billing/methods" element={<BillingMethodListing />} />
                <Route path="/billing/methods/add" element={<AddBillingMethod />} />
              </>
              :
              null
          }

          <Route path="/profile" element={<Profile />} />

          <Route path="/clinics/add" element={<AddClinic />} />
          <Route path="/clinics" element={<ClinicListing />} />
          <Route path="/clinics/:id" element={<ClinicDetail />} />
          <Route path="/billing-methods/:id" element={<BillingMethodDetail />} />
          <Route path="/cases/add" element={<AddCase />} />
          <Route path="/cases/add/patient/:patient_id_in_url" element={<AddCase />} />
          <Route path="/cases" element={<CaseListing />} />
          <Route path="/cases/:id" element={<CaseDetail />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support/:id" element={<SupportDetail />} />
          {/* <Route path="/courses" element={<CoursesListing />} /> */}
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<CourseDetail />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/deliveries" element={<Deliveries />} />
          <Route path="/statistics" element={<Stats />} />
          <Route path="/ai" element={<Indexes />} />
          <Route path="/ai/:id" element={<IndexesDetail />} />
          <Route path="/case-studies" element={<DoctorCaseStudies />} />
          <Route path="/case-studies/:id" element={<DoctorCaseStudyDetail />} />
          {
            user.is_ceph_user ?
              <>
                <Route path="/ceph-analysis" element={<CephAnalysis />} />
                <Route path="/ceph-analysis/:id" element={<CephAnalysisDetail />} />
              </>
              :
              null
          }


          <Route path='*' element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </>
  )
}

export default AdminRoutes
